// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import cogoToast from "cogo-toast";
// import { VERIFY_PAYMENT_LINK } from "../api/utils";
// // import LoadingSpinner from "../components/LoadingSpinner"; // Assuming you have a spinner component

// export default function PaymentCallback() {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [verificationStatus, setVerificationStatus] = useState('processing'); // 'processing', 'success', 'failed'
//     const [countdown, setCountdown] = useState(5);

//     useEffect(() => {
//         const verifyPayment = async () => {
//             const params = new URLSearchParams(location.search);
            
//             // Check if we have all required parameters
//             const requiredParams = [
//                 'razorpay_payment_id',
//                 'razorpay_payment_link_id',
//                 'razorpay_payment_link_reference_id',
//                 'razorpay_payment_link_status',
//                 'razorpay_signature'
//             ];
            
//             const missingParams = requiredParams.filter(param => !params.get(param));
            
//             if (missingParams.length > 0) {
//                 setVerificationStatus('failed');
//                 cogoToast.error("Missing payment information. Please contact support.");
//                 return;
//             }

//             try {
//                 const response = await axios.get(VERIFY_PAYMENT_LINK, {
//                     params: {
//                         razorpay_payment_id: params.get('razorpay_payment_id'),
//                         razorpay_payment_link_id: params.get('razorpay_payment_link_id'),
//                         razorpay_payment_link_reference_id: params.get('razorpay_payment_link_reference_id'),
//                         razorpay_payment_link_status: params.get('razorpay_payment_link_status'),
//                         razorpay_signature: params.get('razorpay_signature')
//                     }
//                 });

//                 if (response.data.status === 'ok') {
//                     setVerificationStatus('success');
//                     cogoToast.success(response.data.message || "Payment verified successfully! You are now registered.");
//                 } else {
//                     setVerificationStatus('failure');
//                     cogoToast.error(response.data.message || "Payment verification failed. Please contact support.");
//                 }
//             } catch (error) {
//                 console.error("Payment verification error:", error);
//                 setVerificationStatus('failed');
//                 const errorMessage = error.response?.data?.message || 
//                                    "An error occurred during payment verification.";
//                 cogoToast.error(errorMessage);
//             }
//         };

//         verifyPayment();
//     }, [location]);

//     // Countdown and redirect logic
//     useEffect(() => {
//         if (verificationStatus !== 'processing' && countdown > 0) {
//             const timer = setTimeout(() => {
//                 setCountdown(countdown - 1);
//             }, 1000);
//             return () => clearTimeout(timer);
//         }

//         if (countdown === 0) {
//             if (verificationStatus === 'success') {
//                 navigate('/registration-success', {
//                     state: { 
//                         message: "Your registration is complete!",
//                         paymentVerified: true
//                     }
//                 });
//             } else {
//                 navigate('/payment-failed', {
//                     state: { 
//                         message: "Payment verification failed",
//                         showRetry: true
//                     }
//                 });
//             }
//         }
//     }, [countdown, verificationStatus, navigate]);

//     const getStatusContent = () => {
//         switch (verificationStatus) {
//             case 'success':
//                 return (
//                     <div className="text-center">
//                         <div className="text-success mb-3">
//                             <i className="bi bi-check-circle-fill" style={{ fontSize: "3rem" }}></i>
//                         </div>
//                         <h4>Payment Verified Successfully!</h4>
//                         <p>Redirecting to confirmation page in {countdown} seconds...</p>
//                         <p>You are now registered for the webinar.</p>
//                     </div>
//                 );
//             case 'failed':
//                 return (
//                     <div className="text-center">
//                         <div className="text-danger mb-3">
//                             <i className="bi bi-x-circle-fill" style={{ fontSize: "3rem" }}></i>
//                         </div>
//                         <h4>Payment Verification Failed</h4>
//                         <p>Redirecting in {countdown} seconds...</p>
//                         <button 
//                             className="btn btn-primary mt-3"
//                             onClick={() => navigate('/payment-retry')}
//                         >
//                             Try Again
//                         </button>
//                     </div>
//                 );
//             default:
//                 return (
//                     <div className="text-center">
//                         {/* <LoadingSpinner size="lg" /> */}
//                         <h4 className="mt-3">Processing your payment...</h4>
//                         <p>Please wait while we verify your payment details.</p>
//                     </div>
//                 );
//         }
//     };

//     return (
//         <div className="container" style={{ 
//             justifyContent: "center", 
//             display: "flex", 
//             minHeight: "100vh",
//             alignItems: "center"
//         }}>
//             <div style={{ maxWidth: "500px", width: "100%" }}>
//                 {getStatusContent()}
//             </div>
//         </div>
//     );
// }
// NEW
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import cogoToast from "cogo-toast";
import { VERIFY_PAYMENT_LINK } from "../api/utils";
export default function PaymentCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying');
    const [countdown, setCountdown] = useState(5);
    const [paymentDetails, setPaymentDetails] = useState(null);

    useEffect(() => {
        const verifyPayment = async () => {
            const params = new URLSearchParams(location.search);
            
            try {
                const response = await axios.get(VERIFY_PAYMENT_LINK, {
                    params: {
                        razorpay_payment_id: params.get('razorpay_payment_id'),
                        razorpay_payment_link_id: params.get('razorpay_payment_link_id'),
                        razorpay_payment_link_reference_id: params.get('razorpay_payment_link_reference_id'),
                        razorpay_payment_link_status: params.get('razorpay_payment_link_status'),
                        razorpay_signature: params.get('razorpay_signature')
                    }
                });

                if (response.data.status === 'ok') {
                    setStatus('success');
                    cogoToast.success("Payment successful! Registration complete.");
                } else {
                    setStatus('failed');
                    setPaymentDetails({
                        status: response.data.payment_status,
                        message: response.data.message
                    });
                    
                    if (response.data.payment_status === 'cancelled') {
                        cogoToast.warn("Payment was cancelled. You can try again.");
                    } else {
                        cogoToast.error("Payment failed. Please try again.");
                    }
                }
            } catch (error) {
                setStatus('error');
                cogoToast.error("Payment verification failed. Please contact support.");
            }
        };

        verifyPayment();
    }, [location]);

useEffect(() => {
    if (status !== 'verifying' && countdown > 0) {
        const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
        return () => clearTimeout(timer);
    }

    if (countdown === 0) {
        if (status === 'success') {
            navigate('/registration-success');
        } else if (status === 'pending') {
            // Handle pending state (payment initiated but not completed)
            navigate('/payment-pending');
        } else {
            navigate('/payment-failed', {
                state: {
                    paymentDetails,
                    showRetry: paymentDetails?.status !== 'cancelled' // Don't show retry for cancelled
                }
            });
        }
    }
}, [countdown, status, navigate, paymentDetails]);
    const renderContent = () => {
        switch (status) {
            case 'success':
                return (
                    <div className="success-message">
                        <h2>Payment Successful!</h2>
                        <p>Redirecting in {countdown} seconds...</p>
                    </div>
                );
            case 'failed':
                return (
                    <div className="failed-message">
                        <h2>
                            {paymentDetails?.status === 'cancelled' 
                                ? "Payment Cancelled" 
                                : "Payment Failed"}
                        </h2>
                        <p>{paymentDetails?.message || "Please try again"}</p>
                        <button 
                            onClick={() => navigate('/payment-failed')}
                            className="retry-button"
                        >
                            Try Again Now
                        </button>
                    </div>
                );
            default:
                return <div className="verifying">Verifying payment...</div>;
        }
    };

    return (
        <div className="payment-callback-container">
            {renderContent()}
        </div>
    );
}

// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import cogoToast from "cogo-toast";
// import { VERIFY_PAYMENT_LINK } from "../api/utils";

// export default function PaymentCallback() {
//     const location = useLocation();
//     const navigate = useNavigate();
//     const [verificationStatus, setVerificationStatus] = useState('processing');
//     const [countdown, setCountdown] = useState(5);
//     const [paymentDetails, setPaymentDetails] = useState(null);

//     useEffect(() => {
//         const verifyPayment = async () => {
//             const params = new URLSearchParams(location.search);
            
//             const requiredParams = [
//                 'razorpay_payment_id',
//                 'razorpay_payment_link_id',
//                 'razorpay_payment_link_reference_id',
//                 'razorpay_payment_link_status',
//                 'razorpay_signature'
//             ];
            
//             const missingParams = requiredParams.filter(param => !params.get(param));
            
//             if (missingParams.length > 0) {
//                 setVerificationStatus('failed');
//                 cogoToast.error("Missing payment information. Please contact support.");
//                 return;
//             }

//             try {
//                 const response = await axios.get(VERIFY_PAYMENT_LINK, {
//                     params: {
//                         razorpay_payment_id: params.get('razorpay_payment_id'),
//                         razorpay_payment_link_id: params.get('razorpay_payment_link_id'),
//                         razorpay_payment_link_reference_id: params.get('razorpay_payment_link_reference_id'),
//                         razorpay_payment_link_status: params.get('razorpay_payment_link_status'),
//                         razorpay_signature: params.get('razorpay_signature')
//                     }
//                 });

//                 if (response.data.status === 'ok') {
//                     setVerificationStatus('success');
//                     cogoToast.success("Payment successful! Registration complete.");
//                 } else {
//                     setVerificationStatus('failed');
//                     setPaymentDetails({
//                         status: response.data.payment_status || 'failed',
//                         message: response.data.message
//                     });
                    
//                     if (response.data.payment_status === 'cancelled') {
//                         cogoToast.warn("Payment was cancelled. Please try again.");
//                     } else {
//                         cogoToast.error(response.data.message || "Payment failed. Please try again.");
//                     }
//                 }
//             } catch (error) {
//                 console.error("Payment verification error:", error);
//                 setVerificationStatus('failed');
//                 const errorMessage = error.response?.data?.message || 
//                                    "Payment verification failed. Please try again.";
//                 cogoToast.error(errorMessage);
//             }
//         };

//         verifyPayment();
//     }, [location]);

//     useEffect(() => {
//         if (verificationStatus !== 'processing' && countdown > 0) {
//             const timer = setTimeout(() => {
//                 setCountdown(countdown - 1);
//             }, 1000);
//             return () => clearTimeout(timer);
//         }

//         if (countdown === 0) {
//             if (verificationStatus === 'success') {
//                 navigate('/registration-success');
//             } else {
//                 navigate('/payment-failed', {
//                     state: { 
//                         paymentDetails,
//                         showRetry: true
//                     }
//                 });
//             }
//         }
//     }, [countdown, verificationStatus, navigate, paymentDetails]);

//     const getStatusContent = () => {
//         switch (verificationStatus) {
//             case 'success':
//                 return (
//                     <div className="text-center">
//                         <div className="text-success mb-3">
//                             <i className="bi bi-check-circle-fill" style={{ fontSize: "3rem" }}></i>
//                         </div>
//                         <h4>Payment Successful!</h4>
//                         <p>Redirecting to confirmation page in {countdown} seconds...</p>
//                     </div>
//                 );
//             case 'failed':
//                 return (
//                     <div className="text-center">
//                         <div className="text-danger mb-3">
//                             <i className="bi bi-x-circle-fill" style={{ fontSize: "3rem" }}></i>
//                         </div>
//                         <h4>
//                             {paymentDetails?.status === 'cancelled' 
//                                 ? "Payment Cancelled" 
//                                 : "Payment Failed"}
//                         </h4>
//                         <p>{paymentDetails?.message || "Please try again"}</p>
//                         <p>Redirecting in {countdown} seconds...</p>
//                         <button 
//                             className="btn btn-primary mt-3"
//                             onClick={() => navigate('/payment-retry')}
//                         >
//                             Try Again Now
//                         </button>
//                     </div>
//                 );
//             default:
//                 return (
//                     <div className="text-center">
//                         <div className="spinner-border text-primary" role="status">
//                             <span className="visually-hidden">Loading...</span>
//                         </div>
//                         <h4 className="mt-3">Verifying Payment...</h4>
//                         <p>Please wait while we process your payment details.</p>
//                     </div>
//                 );
//         }
//     };

//     return (
//         <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
//             <div className="card p-4" style={{ maxWidth: "500px", width: "100%" }}>
//                 {getStatusContent()}
//             </div>
//         </div>
//     );
// }